<template>
  <div>
    <Header></Header>
    <div class="banner">
      <div class="word">
        <div class="containerTit">
          建设咨询
        </div>
        <div class="line">
          ——
        </div>
      </div>
    </div>
     <div class="pageTit">支持以下方面的建设咨询</div>
     <div class="content">
        <div class="conBox" v-for="(item, idx) in list" :key="item.title" @mousemove='ptIndex = idx' @mouseout='ptIndex = null'>
          <img v-if="ptIndex === idx" :src="baseURL+item.selectLogo" class="cIcon" />
          <img v-else :src="baseURL+item.logo" class="cIcon" />

          <div class="cTit" :class="{'active': ptIndex === idx}">{{item.title}}</div>
          <div class="cText" :class="{'active': ptIndex === idx}">{{item.contentTitle}}</div>
        </div>
      </div>
    <Contact/>
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import { contentByType } from '@/api/api'
  import {serverUrl} from '@/utils/server.js'
  import Contact from './Contact.vue'
  export default {
    data() {
      return {
        ptIndex: null,
        baseURL: serverUrl.baseURL,
        list: [
          {
            icon: require('../../assets/images/build1.png'),
            iconHover: require('../../assets/images/build1_a.png'),
            title:'标识应用定制开发',
            content: '基于二级节点平台，研发与集成行业应用'
          },
          {
            icon: require('../../assets/images/build2.png'),
            iconHover: require('../../assets/images/build2_a.png'),
            title:'标识应用定制开发',
            content: '基于二级节点平台，研发与集成行业应用'
          },
          {
            icon: require('../../assets/images/build3.png'),
            iconHover: require('../../assets/images/build3_a.png'),
            title:'标识应用定制开发',
            content: '基于二级节点平台，研发与集成行业应用'
          },
          {
            icon: require('../../assets/images/build4.png'),
            iconHover: require('../../assets/images/build4_a.png'),
            title:'标识应用定制开发',
            content: '基于二级节点平台，研发与集成行业应用'
          },
          {
            icon: require('../../assets/images/build5.png'),
            iconHover: require('../../assets/images/build5_a.png'),
            title:'标识应用定制开发',
            content: '基于二级节点平台，研发与集成行业应用'
          },
          {
            icon: require('../../assets/images/build6.png'),
            iconHover: require('../../assets/images/build6_a.png'),
            title:'标识应用定制开发',
            content: '基于二级节点平台，研发与集成行业应用'
          }
        ]
      }
    },
    components: {
      Header,
      Footer,
      Contact
    },
    mounted() {
      this.getContentByType()
    },
    methods: {
      getContentByType() {
        contentByType({type: 3}).then(res=> {
          // todo 数据差滑过的图片
          this.list=res.data
        })
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 480px;
    background: url(../../assets/images/buildBanner.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }
  .containerTit{
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }
  .line {
    font-size: 16px;
    font-family: Adobe Heiti Std;
    color: #FFFFFF;
    line-height: 46px;
  }
  .word{
    width: 1300px;
    margin: 0 auto;
  }
  .content{
    width: 1300px;
    margin: 0 auto 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .conBox{
    width: 400px;
    height: 305px;
    background: #F8F8F8;
    box-sizing: border-box;
    padding-left: 62px;
    padding-top: 57px;
    margin-bottom: 60px;
  }
  .cIcon{
    width: 66px;
  }
  .cTit{
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-top: 38px;
    margin-bottom: 23px;
  }
  .cText{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #7D889B;
    line-height: 28px
  }
  .pageTit{
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding: 130px 0 70px;
  }
  .cTit.active{
    color: #fff;
  }
  .cText.active{
    color: #fff;
  }
  .conBox:hover{
    background: url('../../assets/images/buildBg.png') top center no-repeat;
    background-size: 100% 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/node/Build.vue